<template>
  <el-cascader
    v-model="selectedValue"
    v-bind="$attrs"
    @change="change"
    @blur="blur"
    @focus="focus"
  >
  </el-cascader>
</template>

<script>
export default {
  name: 'RtCascader',
  props: {
    value: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      selectedValue: this.value
    };
  },
  watch: {
    value(newVal, oldVal) {
      this.selectedValue = newVal;
    }
  },
  methods: {
    change(val) {
      this.$emit('input', val);
    },
    blur() {
      this.$emit('blur');
    },
    focus() {
      this.$emit('focus');
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtCascader.vue?4521e002